import { push } from 'connected-react-router'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'
import { withStyles } from '@material-ui/core'

import { routeNameSelector } from 'reduxModules/selectors/RouteSelectors'
import { dateSelector } from 'reduxModules/selectors/DateSelectors'
import { userNameSelector } from 'reduxModules/selectors/UserSelectors'
import {
  isLogisticPageSelector,
  isPricesPageSelector, 
  isUsersPageSelector,
  isWebsiteBookingsPageSelector
} from 'reduxModules/selectors/RouterSelectors'
import { authActions } from 'reduxModules/actions/AuthActions'

import { HeaderBase } from './Header'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  date: dateSelector,
  userName: userNameSelector,
  routeName: routeNameSelector,
  isUsersPage: isUsersPageSelector,
  isPricesPage: isPricesPageSelector,
  isLogisticPage: isLogisticPageSelector,
  isWebsiteBookingsPage: isWebsiteBookingsPageSelector,
})

const mapDispatchToProps = {
  push: push,
  signOut: authActions.signOut,
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)

export const Header = enhance(HeaderBase)



// WEBPACK FOOTER //
// ./src/components/Header/index.js